export default __webpack_public_path__ + "static/media/1877.e48ff1e8.png";